import getCorePopUpStore from "../../stores/core/core-popup-store";
import { withLiteObserverAndTheme } from "../et3-enhanced-render";
import AlertPopUp from "./alert-pop-up";
import getCoreUIStore from "../../stores/core/core-ui-store";

const Et3AlertPopUp = withLiteObserverAndTheme(() => {
  const shouldShowAlert = getCorePopUpStore().isAlertVisible.get();
  getCorePopUpStore().isShowUpdatePasswordPopUpVisible.get();
  const mainWidth = getCoreUIStore().mainWidth.get();

  switch (true) {
    case shouldShowAlert:
      return <AlertPopUp width={mainWidth} />;
    default:
      return <></>;
  }
});
export default Et3AlertPopUp;
